module.exports = __webpack_public_path__ + "img/logo.74800b3a.svg";